var exports = {
  "oR": "Toast.module__toast___Q01fd3",
  "Gv": "Toast.module__toastMobile___Q01fd3",
  "qS": "Toast.module__toastDesktop___Q01fd3",
  "Kk": "Toast.module__icon___Q01fd3",
  "PO": "Toast.module__iconSuccess___Q01fd3",
  "m5": "Toast.module__iconError___Q01fd3",
  "oq": "Toast.module__iconMobile___Q01fd3",
  "gB": "Toast.module__iconDesktop___Q01fd3",
  "Qq": "Toast.module__text___Q01fd3",
  "wV": "Toast.module__textMobile___Q01fd3",
  "eL": "Toast.module__textDesktop___Q01fd3",
};

module.exports = exports;
